export const getInitialLetter = (name) => {
    if (!name || typeof name !== 'string') {
      return ''; // Manejo de casos en los que el nombre no sea válido
    }
  
    const names = name.trim().split(' ').filter(Boolean); // Filtra strings vacíos
    let initials = '';
  
    if (names.length > 1) {
      initials = names[0][0] + names[names.length - 1][0];
    } else {
      initials = names[0][0];
    }
  
    return initials.toUpperCase();
  };